import { Toast, Tooltip } from './_bootstrap';

(() => {
	// * Tooltip initialization, remove it if not necessary
	for (const tooltipElement of document.querySelectorAll(
		'[data-toggle="tooltip"]',
	)) {
		new Tooltip(tooltipElement);
	}

	// * Toast initialization, remove it if not necessary
	for (const toastElement of document.querySelectorAll(".toast")) {
		new Toast(toastElement);
	}
})();

(function($) {
	$(document).ready(function() {

		$('.views-field-field-review-photo').photobox('a',{ time:0 });
		$('.field--name-field-gallery').photobox('a',{ time:0 });

		$('.fancy-form').fancybox();
		$('.fancy-img').fancybox();

		function hidelogo1() {
			$('#logo_video').addClass("hide_logo1");
		}
		function hidelogo2() {
			$('#logo_video').addClass("hide_logo2");
		}
		setTimeout(hidelogo1, 5000);
		setTimeout(hidelogo2, 7000);

	});
})(jQuery);